import { useState, useEffect } from 'react';

export const useDesktopSiteDetection = (mobileMaxWidth = 480) => {
  const [isDesktopSiteOnMobile, setIsDesktopSiteOnMobile] = useState(false);

  useEffect(() => {
    const detectDesktopSite = () => {

      const viewportMeta = document.querySelector('meta[name="viewport"]');
      const usingMobileViewport = viewportMeta && viewportMeta.content.includes('width=device-width');
      const smallScreen = window.screen.width <= mobileMaxWidth;
      
      setIsDesktopSiteOnMobile(smallScreen && !usingMobileViewport);
    };
    
    detectDesktopSite();
    window.addEventListener('resize', detectDesktopSite);
    return () => window.removeEventListener('resize', detectDesktopSite);
  }, [mobileMaxWidth]);

  return isDesktopSiteOnMobile;
};